// extracted by mini-css-extract-plugin
export var introContainer = "IntroText-module--introContainer---mDrg";